// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".PromptTriggerRule__container___2tzLU{border-bottom:1px solid rgba(0,0,0,0.1);margin-bottom:8px}.PromptTriggerRule__ruleRow___2Z4xe{display:flex}.PromptTriggerRule__valueColumn___3Hgpd{flex:1}.PromptTriggerRule__actionIcons___3V4d5{margin-top:28px;height:24px}.PromptTriggerRule__errorMessage___24usb{color:#ff0c0c}\n", ""]);
// Exports
exports.locals = {
	"container": "PromptTriggerRule__container___2tzLU",
	"ruleRow": "PromptTriggerRule__ruleRow___2Z4xe",
	"valueColumn": "PromptTriggerRule__valueColumn___3Hgpd",
	"actionIcons": "PromptTriggerRule__actionIcons___3V4d5",
	"errorMessage": "PromptTriggerRule__errorMessage___24usb"
};
module.exports = exports;
